import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { EncryptedLoginComponent, LoginForm } from "../components/auth";
import { useSelector } from "react-redux";
import { RootState } from "store";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  const searchParams = useQuery();
  const emailId = searchParams.get("email");
  const name = searchParams.get("name");

  const router = useNavigate();
  const [isEmailLink, setIsEmailLink] = useState(false);
  const [isNameLink, setIsNameLink] = useState(false);

  const navigate = useNavigate();
  const { user, isLoading } = useSelector((state: RootState) => state.auth);

  useEffect(() => {

    // const isMobileDevice = /Android|webOS|iPhone|iPad/i.test(navigator.userAgent);
    if (user) {
      // if (isMobileDevice) {
      //   navigate("/device");
      // }    
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [user, navigate]);

  // useEffect(() => {
  //   if (emailId) {
  //     setIsEmailLink(true);
  //   }
  //   if (name) {
  //     setIsNameLink(true);
  //   }

  //   if (router.isReady) {
  //     const hasEmailAndNameParams =
  //       typeof router.query.email === "string" &&
  //       typeof router.query.name === "string";
  //     setIsEmailLink(hasEmailAndNameParams);
  //   }
  // }, [router.isReady, emailId, name, router.query.email, router.query.name]); // Include router.query.email and router.query.name in the dependency array

  return <>{isEmailLink ? <EncryptedLoginComponent /> : <LoginForm />}</>;
}

export default Login;
